/**
 * @description Masters Store Module
 * @author Fahid Mohammad
 */
const VueCookie = require('vue-cookie')
import API from "../../services/api"
export default {
    namespaced: true,
    state: {
        setemp: null,
        edittestcost: null,
        geturl: null
    },
    mutations: {
        GET_PACKAGES: (state, data) => {
            state.packagesData = data
        },

        SET_MASTER_EMPLOYEE: (state, data) => {
            state.setemp = data;
        },
        SET_URLNAME: (state, data) => {
            state.geturl = data;
        },
        SET_TEST_COST: () => {
            state.edittestcost = data;
        },
    },
    actions: {

        SET_MASTER_EMPLOYEE({ commit }, data) {
            commit('SET_MASTER_EMPLOYEE', data)
            if (data && data.employee) {
                commit('SET_URLNAME', data.employee == 4 ? 'addTest' : data.employee == 2 ? 'addTreatment' : 'addTask')
            }
            else if (data) {
                commit('SET_URLNAME', data)
            }
        },

        SET_TEST_COST({ commit }, data) {
            API.updateTreatphiso(data, function (response) {
                let _self = this
                if (response.status === 1000) {
                    commit('SET_TEST_COST', response.data)

                }
            })
        }

    },
    getters: {
        setemp: state => { return state.setemp },
        edittestcost: state => { return state.edittestcost },
        geturl: state => { return state.geturl }
    }
}




// WEBPACK FOOTER //
// ./src/store/modules/masters.js